import { css } from '@emotion/css';
import { verticalStyle } from 'Shared/backend/Theme';
import { theme } from 'Shared/ThemeProvider';
import { Checkbox, Text } from 'Shared/forms/Inputs';
import { LabelOnRightWrap, Wrap } from 'Shared/forms/Wrap';
import { Match, Show, Switch } from 'solid-js';


export function AddButton(P)
{
	const testButtonStyle = css({
		display: 'flex',
		alignItems: 'center',
		gap: '0.5em'
	});

	const paneStyle = css(verticalStyle(), {
		//TODO Share with slide style...
		borderLeft: 'solid 5px #f4f4f4',
		paddingLeft: '1em'
	});


	//XXX sanity check if google doc url doesn't contain /edit?usp=sharing we can't convert it to a PDF

	//XXX is this file a duplicate? Maybe in part?

	const googleDocPDFConvert = () => P.link?.includes('google.com/document/') && P.link?.includes('/edit?usp=sharing');

	const googleLink = () => P.gDriveDownloadAsPDF ? P.link.replace('/edit?usp=sharing','/export?format=pdf') : P.link;

	return (
		<div class={paneStyle}>
			<Wrap label='Button Link'>
				<Text field='link' placeholder='eg https://webaddress | page title for your own site eg /contact | google doc share link for download'/>
			</Wrap>

			<Switch>
				<Match when={googleDocPDFConvert()}>
					<LabelOnRightWrap label='Convert Google Doc to a PDF when users download it'>
						<Checkbox field='gDriveDownloadAsPDF' />
					</LabelOnRightWrap>
				</Match>
				<Match when={true}>
					<LabelOnRightWrap label='Open link on the same window'>
						<Checkbox field='openInSameWindow' />
					</LabelOnRightWrap>
				</Match>
			</Switch>

			<Wrap label='Button Text'>
				<Text field='text' placeholder='More Info' />
			</Wrap>

			<Show when={googleDocPDFConvert()}>
				<div class={testButtonStyle}> 
					<h4 class={css(theme().section.heading)}>Test your button:</h4>

					<a href={googleLink()} target='_blank'>
						<button class={css(theme().button)} >
							{P.text ?? 'More Info'}
						</button>
					</a>
				</div>
			</Show>
		</div>
	);
}

